module.exports = __webpack_public_path__ + "static/media/Willet Hossfeld_1669835332386.142235bc.jpg";